import * as React from 'react'
import { useRouter } from 'next/router'
import { NextSeo, BreadcrumbJsonLd, CarouselJsonLd } from 'next-seo'

import { CollectionItem } from 'components/atomic/molecules/collection'

import Routes, { toAbsoluteUrl } from 'utils/routes'

interface SEOProps {
    title: string
    description: string
    items: CollectionItem[]
    breadcrumbs: {
        name: string
        path: string
    }[]
    imageName?: string
}

const SEO = ({ title, description, items, breadcrumbs, imageName }: SEOProps) => {
    const router = useRouter()

    const keywords = [
        'corsi di programmazione gratis',
        'corsi linguaggi di programmazione',
        'diventare programmatore',
        'impara a programmare',
    ]

    return (
        <>
            <NextSeo
                title={title}
                titleTemplate={'%s | Devv'}
                description={description}
                canonical={`${toAbsoluteUrl(router.asPath)}`}
                additionalMetaTags={[
                    {
                        property: 'keywords',
                        content: keywords.join(', '),
                    },
                ]}
                openGraph={{
                    url: `${toAbsoluteUrl(router.asPath)}`,
                    images: [
                        {
                            url: `${toAbsoluteUrl(`/assets/og/${imageName}.png`)}`,
                            secureUrl: `${toAbsoluteUrl(`/assets/og/${imageName}.png`)}`,
                            type: 'image/png',
                            width: 1200,
                            height: 630,
                            alt: `Sfoglia il catalogo di percorsi di Devv`,
                        },
                    ],
                }}
            />
            <BreadcrumbJsonLd
                itemListElements={breadcrumbs.map((e, index) => ({
                    position: index + 1,
                    name: e.name,
                    item: `${toAbsoluteUrl(e.path)}`,
                }))}
            />
            <CarouselJsonLd
                ofType="course"
                data={items.map((e) => ({
                    courseName: e.item.title,
                    description: e.item.short_description,
                    providerName: 'Devv',
                    url: `${toAbsoluteUrl(Routes.LearningItem(`${e.type}s`, e.item.slug))}`,
                }))}
            />
        </>
    )
}

export default SEO
